import constants from '@/mc/constants';

// 获取房型列表
export function login(data){
    return {
        type:constants.H_ROOM_TYPE_LIST,
        data:data
    }
}